import { Descendant } from 'slate';

import { FormulaType } from '../constants/formulaType';

// models
import { ElementKind } from './editor.model';
import { BasePaginatedResponse } from './pagination';

export const FORMULA_TEMPLATE_DEFAULT_PER_PAGE = 10;

interface TagModel {
    id: number;
    name: string;
    tag_type: string;
}

export interface Tag {
    id: number;
    sample_message_id: number;
    tag_id: number;
    tag: TagModel;
}

export interface SampleModel {
    id: number;
    name: string | null;
    origin: string;
    structure: Descendant[];
    language: string;
    active: boolean;
    annotated: boolean;
    created_at: string;
    created_by_id: number;
    first_sent: string;
    last_sent: string;
    message_type: FormulaType;
    tags: Tag[];
    total_sent: number;
}

export interface SampleDataModel {
    items: SampleModel[];
    count: number;
}

export interface SampleDataParamModel {
    annotated_only?: boolean;
    industries?: number[];
    origins?: string[];
    months?: number[];
}

export interface IndustryTagsDataModel {
    id: number;
    name: string;
    tag_type: string;
}

export interface OriginDataModel {
    items: string[];
}

export interface SamplesFiltersFormikValues {
    industries?: (number | string)[];
    origins?: string[];
    months?: (number | string)[];
}

export enum FilterAllOption {
    All = 'All',
}
export const monthOptions = [
    {
        label: FilterAllOption.All,
        value: FilterAllOption.All,
    },
    { label: 'January', value: 1 },
    { label: 'February', value: 2 },
    { label: 'March', value: 3 },
    { label: 'April', value: 4 },
    { label: 'May', value: 5 },
    { label: 'June', value: 6 },
    { label: 'July', value: 7 },
    { label: 'August', value: 8 },
    { label: 'September', value: 9 },
    { label: 'October', value: 10 },
    { label: 'November', value: 11 },
    { label: 'December', value: 12 },
];

export enum InspirationTabs {
    MessageTemplates = 'message_templates',
    ExternalMessageTemplates = 'external_message_templates',
}

export enum IndustryType {
    Ecommerce = 'e_commerce',
    Delivery = 'delivery_food_groceries',
    HealthFitness = 'health_fitness',
    Entertainment = 'entertainment_streaming_music_sports',
    Fintech = 'fintech',
}

export enum TemplateType {
    Triggered = 'triggered',
    NonTriggered = 'non_triggered',
    Recommender = 'recommender',
}

export enum UseCaseType {
    CartAbandonment = 'cart_abandonment',
    BrowseAbandonment = 'browse_abandonment',
    UserActivation = 'user_activation',
    Engagement = 'engagement',
}

type StructureByChannel = {
    [key in FormulaType]: Descendant[];
};
export interface FormulaTemplate {
    id: string;
    name: string;
    industry: IndustryType;
    template_type: TemplateType;
    use_case: UseCaseType;
    structure_by_channel: StructureByChannel;
}
export interface FormulaTemplatesDataModel
    extends BasePaginatedResponse<FormulaTemplate> {}

export interface StructureTextModel {
    text: string;
    isHighlighted?: boolean;
    elementId?: string;
    variantType?: string;
    kind?: ElementKind;
    cmsPlaceholderId?: string;
    datasetId?: number;
    datasetField?: number;
}

export interface TemplateVariant {
    content: string;
    id: string;
    variant_type: string;
}

export interface TemplateAlternateTextModel {
    id: string;
    template_id: string;
    alternate_variant_id: string;
    original_variant_id: string;
    alternate_variant: TemplateVariant;
}

export type HighlightTextModel = {
    isHighlighted: boolean;
    color?: string;
    bgColor?: string;
};

type AllTemplateEnums = IndustryType | TemplateType | UseCaseType;
export const DisplayTemplateEnums: {
    [key in AllTemplateEnums]: { text: string };
} = {
    [IndustryType.Ecommerce]: { text: 'E-commerce' },
    [IndustryType.Delivery]: { text: 'Delivery' },
    [IndustryType.HealthFitness]: { text: 'Health & Fitness' },
    [IndustryType.Entertainment]: { text: 'Entertainment' },
    [IndustryType.Fintech]: { text: 'Fintech' },

    [TemplateType.Triggered]: { text: 'Triggered' },
    [TemplateType.NonTriggered]: { text: 'Non-triggerd' },
    [TemplateType.Recommender]: { text: 'Recommender' },

    [UseCaseType.CartAbandonment]: { text: 'Cart abandonment' },
    [UseCaseType.BrowseAbandonment]: { text: 'Browse abandonment' },
    [UseCaseType.UserActivation]: { text: 'User activation' },
    [UseCaseType.Engagement]: { text: 'Engagement' },
};

export type StyledBoxType = {
    variantType?: string;
};

export interface TemplateFiltersFormikValues {
    industries: string[];
    template_types: string[];
    use_cases: string[];
}

export interface TemplateFilterParams {
    industries?: IndustryType[];
    template_types?: TemplateType[];
    use_cases?: UseCaseType[];
}

export interface CreateFormulaFromTemplate {
    name: string;
    formula_template_id: string;
}
